import { useCallback } from "react";
import { APP_EVENTS } from "shared/events";
import { usePostMessageConfig } from "./config";

const useShowCustomQrModal = () => {
	const { triggerEvent } = usePostMessageConfig();

	const triggerShowCustomQrModal = useCallback((data = {}) => {
		triggerEvent(APP_EVENTS.CUSTOM_AR_QR_MODAL, data);
	}, [triggerEvent]);

	return { triggerShowCustomQrModal };
};

export default useShowCustomQrModal;
